import { stringifySearchParamOptions } from "@/components/pageCards/filterSort/searchParams";
import { CustomerLogoView } from "@/pages/customer/components/CustomerDrawer/CustomerLogoView";

import { Link } from "react-router-dom";

import type { TenantContaminationRow } from "./types";

type Props = {
  row: TenantContaminationRow;
  sitePath: string;
  timeFilterUrlParam: string;
};

export const TenantContaminationRowView: React.FC<Props> = ({
  row,
  sitePath,
  timeFilterUrlParam,
}) => {
  return (
    <tr key={row.id} className="border-grey2 border-t">
      <td className="px-[12px] py-[12px]">
        <div className="flex items-center gap-[10px]">
          <CustomerLogoView
            customerId={row.id}
            customerName={row.name}
            size={28}
            className=""
            editable={false}
          />
          <span className="inline-flex items-center gap-[6px] text-[13.5px] font-semibold whitespace-nowrap">
            {row.name}
          </span>
        </div>
      </td>
      <td className="px-[12px] py-[12px] text-right text-[13px]">
        <Link
          to={{
            pathname: `${sitePath}/events`,
            search: stringifySearchParamOptions({
              customerId: row.id,
              contamination: "true",
              timeframe: timeFilterUrlParam,
            }),
          }}
          className="decoration-grey3 font-semibold text-[#1D1C1C] underline underline-offset-2"
        >
          {row.nrLoads}
        </Link>
      </td>
      <td className="px-[12px] py-[12px] text-right whitespace-nowrap">
        <span className="font-signifier text-[15px] font-bold">
          {row.contaminatedWeight.toFixed(1)}
        </span>
        <span className="text-grey6 ml-[3px] text-[11px]">kg</span>
      </td>
      <td className="px-[12px] py-[12px] text-right">
        <span className="text-[13px] font-semibold whitespace-nowrap">
          {row.contaminationRate.toFixed(1)} %
        </span>
      </td>
    </tr>
  );
};
